import { RepoTypes } from 'common-types';

export interface Exclusion {
  id: string;
  exclusionType: ExclusionTypeRaw;
  exclusionId: string;
  modifiedBy: string;
  modifiedIssues: number;
  createdAt: Date;
  updatedAt: Date;
  exclusionAppliedOn: string;
  exclusionMatch: ExclusionMatch[];
  appName: string;
  policyName: string;
  appType: RepoTypes;
  comment: string;
  index: number;
  expiredAt?: Date | null;
  isActive: boolean;
  inDayExpired: boolean | null;
  inWeekExpired: boolean | null;
}

export interface ExclusionMatch {
  key: string;
  value: string;
}

export interface ExclusionResponse {
  exclusions: Exclusion[];
  totalExclusions: number;
  totalFilteredExclusions: number;
}

export interface FetchExclusionsResponse {
  getAllExclusions: ExclusionResponse;
  getExclusionsFilters: ExclusionsFilters;
}

export enum ExclusionType {
  policy = 'Policy disabled',
  application = 'App set to irrelevant',
  alert = 'Issue excluded',
}

export enum ExclusionTypeRaw {
  policy = 'policy',
  application = 'application',
  alert = 'alert',
}

export enum ExclusionSortKey {
  ExclusionType = 'Type',
  ModifiedIssues = 'Initial Modified issues count',
  ModifiedBy = 'Created By',
  ExcludedDate = 'Excluded Date',
  AppliedOn = 'Issue',
  Match = 'Match',
  AppName = 'Application Name',
  Policy = 'Policy Name',
  Comment = 'Comment',
  MenuOptions = 'Menu Options',
  Snooze = 'Snooze',
}

export enum ExclusionsOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export interface ExcludeApplicationsResponse {
  exclusions: Exclusion[];
}

export interface ExcludePolicyResponse {
  excludePolicy: Exclusion;
}

export interface ExcludeInput {
  appId: string;
  appName: string;
  issueName: string;
  policyId: string;
  policyName: string;
  issueId: string;
  appType: string;
  policyCategory: string;
  comment?: string;
}

export interface ExcludeAppInput {
  appId: string;
  appName: string;
  comment?: string;
}

export interface ExcludeAlertInput {
  oxIssueId: string;
  issueId: string;
  alertId?: string;
  issueName: string;
  rule: {
    exclusionCategory: ExclusionCategory;
    aggs: string[];
    id: string;
  };
  appId: string;
  appName: string;
  policyId: string;
  policyName: string;
  appType: string;
  policyCategory: string;
  comment?: string;
  exclusionMode: ExclusionMode;
  exclusionId?: string;
  expiredAt?: Date;
}

export interface ExcludeAlertsResponse {
  exclusions: Exclusion[];
}

export enum ExclusionCategory {
  Commits = 'commits',
  Cspm = 'cspm',
  General = 'general',
  Iac = 'iac',
  Sast = 'sast',
  Sca = 'sca',
  Secrets = 'secrets',
  Webhooks = 'webhooks',
}

export enum MakeRelevantType {
  Default = 'default',
  Always = 'always',
}

export enum ExclusionMode {
  fullScan = 'fullScan',
  deltaScan = 'deltaScan',
  pipelineScan = 'pipelineScan',
}

export enum ExclusionsMatchTypes {
  realMatch = 'Match',
  fileName = 'File Name',
  source = 'Source',
  applicaiton = 'Application',
  policy = 'Policy',
  alert = 'Alert',
  sha = 'SHA',
  image = 'Image',
  service = 'Service',
  resource = 'Resource',
  accountId = 'Account ID',
  ruleId = 'Rule ID',
  user = 'User',
  url = 'URL',
}

export interface UpdateExpiredAtByIdInput {
  exclusionId: string;
  expiredAt?: Date | null;
}

export interface FetchExclusionsInput {
  filters?: ExclusionsFilters;
}

export interface ExclusionsFilters {
  appName?: string[];
  exclusionType?: string[];
  policyName?: string[];
  modifiedBy?: string[];
  issueName?: string[];
}

export type LoadExclusionssParams = {
  update?: boolean;
};
